<template>
  <div class="download">
    <Header />
    <div class="main-container">
      <div class="left">
        <div class="title">
          {{ config.app_name }}
        </div>
        <div class="sub-title">
          {{ config.app_slogan }}
        </div>
        <div class="app-wrap">
          <img class="img-qrcode" :src="config.app_qr_img" />
        </div>
      </div>
      <img class="banner right" :src="config.banner_img" />
    </div>
    <Footer class="footer" />
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
export default {
  name: "Download",
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      key: "download_android_code",
      config: {},
    };
  },
  async created() {
    let data = await this.$http.get("/api/app/config/app_download");
    this.config = data.app_download;
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.download {
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100vh;
  .main-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 70px;
    box-sizing: border-box;
  }
  .banner {
    width: calc(100vw * 528 / 1920);
    height: calc(100vw * 632 / 1920);
    max-width: 528px;
  }
  .title {
    color: #595959;
    line-height: 1;
    font-size: calc(100vw * 54 / 1920);
    margin-bottom: calc(100vw * 31 / 1920);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .sub-title {
    font-size: calc(100vw * 34 / 1920);
    font-family: PingFang SC;
    font-weight: 300;
    color: #595959;
    line-height: 1.5;
    margin-bottom: calc(100vw * 41 / 1920);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    width: 18em;
  }
  .app-wrap {
    display: flex;
    .img-qrcode {
      width: calc(100vw * 172 / 1920);
      height: calc(100vw * 173 / 1920);
      border: 1px solid rgba(225, 225, 225, 1);
    }
  }
}
.footer {
  width: 100%;
  padding: calc(100vw * 32 / 1920) 0 calc(100vw * 31 / 1920) 0;
  /deep/ {
    .copyright {
      margin-top: calc(100vw * 13 / 1920);
    }
  }
}
@media screen and (min-width: 1920px) {
  .download {
    .banner {
      width: 528px;
      height: 632px;
    }
    .title {
      font-size: 54px;
      margin-bottom: 31px;
    }
    .sub-title {
      font-size: 34px;
      margin-bottom: 41px;
    }
    .app-wrap {
      .img-qrcode {
        width: 172px;
        height: 173px;
      }
    }
  }
  .footer {
    padding: 32px 0 31px 0;
    /deep/ {
      .copyright {
        margin-top: 13px;
      }
    }
  }
}
</style>
